/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DokumentUploadAktualisierenRequest { 
    dokument_id: string;
    dokument_upload_id: string;
    dateiname: string;
    gruppierung?: string;
}

